import { BASE_SERVICE_URL } from '../lib/constants'
// TODO: incluir datereference no database
export default function(database) {
    // console.log(database)
    return fetch(BASE_SERVICE_URL + `/models`, {
        credentials: 'same-origin',
        method: 'PUT',
        headers: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            ...database
        })
    }).then(response => {
        if (response.ok) {
            return response.json()
        } else {
            const error = new Error(response.statusText)

            error.response = response
            throw error
        }
    })
}
